<template>
  <div class="cart_course_item p-2 my-2">
    <div class="d-flex justify-start align-center gap">
      <div class="align-self-start">
        <v-badge :content="item.list_liaisons.length" color="darkblue" inline><v-icon icon="mdi-flag-variant" color="primary" size="x-large"></v-icon></v-badge>
      </div>
      <div>
        <div class="text-subtitle-2">Pack de courses</div>
        <div class="text-body-2">{{ item.nom }}</div>
      </div>
      <div class="justify-self-end text-h6">
        <span v-if="item.current_price">{{ item.current_price }}€</span><span v-else>Gratuit</span>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="d-flex justify-start align-center gap" v-for="course in item.list_liaisons" :key="course.id">
      <div class="text-body-2"><v-icon icon="mdi-plus" color="primary" size="x-large"></v-icon> {{ course.nom_course }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
};
</script>

<style lang="scss" scoped>
</style>